export const DASH_PLACEHOLDER = "-";
